import { action, observable, makeObservable } from 'mobx';

class BaseViewStore {
	timeoutDuration = 2000;

	// Loading flag
	@observable loading = false;
	@observable pendingLoading = false;
	@action suspend = () => {
		this.loading = true;
		clearTimeout(this.pendingLoading);
		this.pendingLoading = null;
	};
	@action resume = () => {
		this.loading = false;
		clearTimeout(this.pendingLoading);
		this.pendingLoading = null;
	};

	@action pendingLoadingSuspend = () => {
		if (this.pendingLoading) {
			return;
		}
		this.pendingLoading = setTimeout(this.suspend, this.timeoutDuration);
	};

	constructor(rootStore) {
		makeObservable(this);
		this.rootStore = rootStore;
	}
}

export default BaseViewStore;



// WEBPACK FOOTER //
// ./src/core/stores/BaseViewStore.js